module.exports = __webpack_public_path__ + "img/01.1826a962.jpg";